import { ICeDocument } from '~/services/api/communityEngagement/types';
import { IResource } from '~/services/api/resource/types';

import CeDocumentStatus from '../constants/CeDocumentStatus';
import formatCeDocument from '../helpers/formatCeDocument';
import { ICeDocumentItem, ISavableCeDocumentItem } from '../types';

export const toCeDocumentItem = (document: ICeDocument): ICeDocumentItem => ({
  key: `existing-${document.id}`,
  status: CeDocumentStatus.Existing,
  fileName: document.fileName,
  document,
});

export const isSavableCeDocument = (item: ICeDocumentItem): item is ISavableCeDocumentItem =>
  item.status === CeDocumentStatus.Existing || item.status === CeDocumentStatus.Uploaded;

export const toCeDocumentPreview = (item: ISavableCeDocumentItem): IResource =>
  formatCeDocument(item.status === CeDocumentStatus.Existing ? item.document : item);
